import { useMemo } from "react";
import { useParams } from "react-router";

import { useClientType } from "hooks/tivoDevices";

import { TiVoDeviceDetails } from "./components/TiVoDeviceDetails";
import { TEXTS } from "./constants";
import { getClientTypeTabs } from "./utils";

export function TiVoClientTypeDetails() {
  const { platformId, oemId, clientTypeId } = useParams();
  const { data, isLoading } = useClientType(platformId, oemId, clientTypeId);
  const clientType = useMemo(() => data?.results, [data?.results]);

  const fields = [
    {
      label: TEXTS.CLIENT_NAME_LABEL,
      value: clientType?.name,
    },
    {
      label: TEXTS.CLIENT_ID_LABEL,
      value: clientType?.id,
    },
    {
      label: TEXTS.CLIENT_SLUG_LABEL,
      value: clientType?.slug,
    },
  ];

  return (
    <TiVoDeviceDetails
      loading={isLoading}
      fields={fields}
      header={TEXTS.CLIENT_DETAILS_HEADER}
      title={clientType?.name || ""}
      tabs={getClientTypeTabs(platformId, oemId, clientTypeId)}
    />
  );
}
